import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';

const BillManagement = () => {
  const [bills, setBills] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingBill, setEditingBill] = useState(null);
  const [sortField, setSortField] = useState('date');
  const [sortOrder, setSortOrder] = useState('desc');
  const [formData, setFormData] = useState({
    date: '',
    amount: '',
    description: '',
    type: 'expense',
    productName: '',
    price: '',
    quantity: '',
    manufacturer: ''
  });

  useEffect(() => {
    // 从localStorage加载账单数据
    const savedBills = localStorage.getItem('bills');
    if (savedBills) {
      setBills(JSON.parse(savedBills));
    }
  }, []);

  const saveBills = (updatedBills) => {
    setBills(updatedBills);
    localStorage.setItem('bills', JSON.stringify(updatedBills));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAddBill = (e) => {
    e.preventDefault();
    const newBill = {
      id: Date.now().toString(),
      ...formData,
      amount: parseFloat(formData.amount),
      price: parseFloat(formData.price),
      quantity: parseFloat(formData.quantity)
    };
    const updatedBills = [...bills, newBill];
    saveBills(updatedBills);
    setFormData({ date: '', amount: '', description: '', type: 'expense', productName: '', price: '', quantity: '', manufacturer: '' });
    setShowAddForm(false);
  };

  const handleEditBill = (bill) => {
    setEditingBill(bill.id);
    setFormData({
      date: bill.date,
      amount: bill.amount.toString(),
      description: bill.description,
      type: bill.type,
      productName: bill.productName || '',
      price: bill.price?.toString() || '',
      quantity: bill.quantity?.toString() || '',
      manufacturer: bill.manufacturer || ''
    });
  };

  const handleUpdateBill = (e) => {
    e.preventDefault();
    const updatedBills = bills.map(bill => 
      bill.id === editingBill 
        ? { 
            ...bill, 
            ...formData, 
            amount: parseFloat(formData.amount),
            price: parseFloat(formData.price),
            quantity: parseFloat(formData.quantity)
          }
        : bill
    );
    saveBills(updatedBills);
    setFormData({ date: '', amount: '', description: '', type: 'expense', productName: '', price: '', quantity: '', manufacturer: '' });
    setEditingBill(null);
  };

  const handleDeleteBill = (id) => {
    if (window.confirm('确定要删除这个账单吗？')) {
      const updatedBills = bills.filter(bill => bill.id !== id);
      saveBills(updatedBills);
    }
  };

  // 打印账单功能
  const handlePrintBill = (bill) => {
    // 创建打印内容
    const printContent = `
      <div class="print-bill">
        <div class="bill-header">
          <h2>货单</h2>
          <div class="bill-date">日期：${bill.date}</div>
        </div>
        <div class="bill-content">
          <div class="bill-section">
            <h3>基本信息</h3>
            <div class="info-row">
              <span class="info-label">类型：</span>
              <span class="info-value">${bill.type === 'income' ? '收入' : '支出'}</span>
            </div>
            <div class="info-row">
              <span class="info-label">描述：</span>
              <span class="info-value">${bill.description}</span>
            </div>
          </div>
          <div class="bill-section">
            <h3>货物信息</h3>
            <table class="items-table">
              <thead>
                <tr>
                  <th>货物名称</th>
                  <th>单价</th>
                  <th>数量</th>
                  <th>厂家</th>
                  <th>金额</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>${bill.productName || '-'}</td>
                  <td>${bill.price || '-'}</td>
                  <td>${bill.quantity || '-'}</td>
                  <td>${bill.manufacturer || '-'}</td>
                  <td>${bill.amount}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="bill-footer">
            <div class="total">总计：${bill.amount}</div>
          </div>
        </div>
      </div>
    `;

    // 创建打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>货单打印</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
            }
            .print-bill {
              width: 100%;
              max-width: 800px;
              margin: 0 auto;
              padding: 20px;
              border: 2px solid #000;
              box-sizing: border-box;
            }
            .bill-header {
              text-align: center;
              margin-bottom: 20px;
              padding-bottom: 10px;
              border-bottom: 2px solid #000;
            }
            .bill-header h2 {
              margin: 0;
              font-size: 24px;
              font-weight: bold;
            }
            .bill-date {
              margin-top: 10px;
              font-size: 14px;
            }
            .bill-section {
              margin-bottom: 20px;
            }
            .bill-section h3 {
              margin: 0 0 10px 0;
              font-size: 16px;
              font-weight: bold;
              border-bottom: 1px solid #000;
              padding-bottom: 5px;
            }
            .info-row {
              margin-bottom: 8px;
            }
            .info-label {
              display: inline-block;
              width: 80px;
              font-weight: bold;
            }
            .items-table {
              width: 100%;
              border-collapse: collapse;
            }
            .items-table th,
            .items-table td {
              border: 1px solid #000;
              padding: 8px;
              text-align: center;
            }
            .items-table th {
              background-color: #f0f0f0;
              font-weight: bold;
            }
            .bill-footer {
              margin-top: 20px;
              padding-top: 10px;
              border-top: 2px solid #000;
              text-align: right;
            }
            .total {
              font-size: 18px;
              font-weight: bold;
            }
          </style>
        </head>
        <body>
          ${printContent}
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() {
                window.close();
              };
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // 导出 Excel 功能
  const handleExportExcel = () => {
    // 准备导出数据
    const exportData = bills.map(bill => ({
      日期: bill.date,
      金额: bill.amount,
      类型: bill.type === 'income' ? '收入' : '支出',
      描述: bill.description,
      货物名称: bill.productName || '-',
      价格: bill.price || '-',
      数量: bill.quantity || '-',
      厂家: bill.manufacturer || '-'
    }));

    // 创建工作簿
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '账单数据');

    // 导出文件
    XLSX.writeFile(workbook, `账单管理_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  // 排序函数
  const sortedBills = [...bills].sort((a, b) => {
    if (sortField === 'date') {
      return sortOrder === 'asc' ? new Date(a.date) - new Date(b.date) : new Date(b.date) - new Date(a.date);
    } else if (sortField === 'amount') {
      return sortOrder === 'asc' ? a.amount - b.amount : b.amount - a.amount;
    }
    return 0;
  });

  // 处理排序字段和顺序变化
  const handleSortChange = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('desc');
    }
  };

  return (
    <div className="bill-management">
      <h2>账单管理</h2>
      <button className="add-button" onClick={() => setShowAddForm(!showAddForm)}>
        {showAddForm ? '取消' : '添加账单'}
      </button>

      {showAddForm && !editingBill && (
        <form className="bill-form" onSubmit={handleAddBill}>
          <div className="form-group">
            <label>日期</label>
            <input type="date" name="date" value={formData.date} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>金额</label>
            <input type="number" name="amount" value={formData.amount} onChange={handleInputChange} step="0.01" required />
          </div>
          <div className="form-group">
            <label>类型</label>
            <select name="type" value={formData.type} onChange={handleInputChange}>
              <option value="expense">支出</option>
              <option value="income">收入</option>
            </select>
          </div>
          <div className="form-group">
            <label>描述</label>
            <input type="text" name="description" value={formData.description} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>货物名称</label>
            <input type="text" name="productName" value={formData.productName} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>价格</label>
            <input type="number" name="price" value={formData.price} onChange={handleInputChange} step="0.01" required />
          </div>
          <div className="form-group">
            <label>数量</label>
            <input type="number" name="quantity" value={formData.quantity} onChange={handleInputChange} step="0.01" required />
          </div>
          <div className="form-group">
            <label>厂家</label>
            <input type="text" name="manufacturer" value={formData.manufacturer} onChange={handleInputChange} required />
          </div>
          <button type="submit">保存</button>
        </form>
      )}

      {editingBill && (
        <form className="bill-form" onSubmit={handleUpdateBill}>
          <div className="form-group">
            <label>日期</label>
            <input type="date" name="date" value={formData.date} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>金额</label>
            <input type="number" name="amount" value={formData.amount} onChange={handleInputChange} step="0.01" required />
          </div>
          <div className="form-group">
            <label>类型</label>
            <select name="type" value={formData.type} onChange={handleInputChange}>
              <option value="expense">支出</option>
              <option value="income">收入</option>
            </select>
          </div>
          <div className="form-group">
            <label>描述</label>
            <input type="text" name="description" value={formData.description} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>货物名称</label>
            <input type="text" name="productName" value={formData.productName} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>价格</label>
            <input type="number" name="price" value={formData.price} onChange={handleInputChange} step="0.01" required />
          </div>
          <div className="form-group">
            <label>数量</label>
            <input type="number" name="quantity" value={formData.quantity} onChange={handleInputChange} step="0.01" required />
          </div>
          <div className="form-group">
            <label>厂家</label>
            <input type="text" name="manufacturer" value={formData.manufacturer} onChange={handleInputChange} required />
          </div>
          <button type="submit">更新</button>
          <button type="button" onClick={() => setEditingBill(null)}>取消</button>
        </form>
      )}

      <div className="bills-list">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
          <h3>账单列表</h3>
          <button className="export-button" onClick={handleExportExcel}>
            导出 Excel
          </button>
        </div>
        <div className="sort-controls">
          <label>排序方式：</label>
          <button 
            className={`sort-button ${sortField === 'date' ? 'active' : ''}`}
            onClick={() => handleSortChange('date')}
          >
            日期 {sortField === 'date' && (sortOrder === 'asc' ? '↑' : '↓')}
          </button>
          <button 
            className={`sort-button ${sortField === 'amount' ? 'active' : ''}`}
            onClick={() => handleSortChange('amount')}
          >
            金额 {sortField === 'amount' && (sortOrder === 'asc' ? '↑' : '↓')}
          </button>
        </div>
        {bills.length === 0 ? (
          <p>暂无账单</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>日期</th>
                <th>金额</th>
                <th>类型</th>
                <th>描述</th>
                <th>货物名称</th>
                <th>价格</th>
                <th>数量</th>
                <th>厂家</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {sortedBills.map(bill => (
                <tr key={bill.id}>
                  <td>{bill.date}</td>
                  <td className={bill.type === 'income' ? 'income' : 'expense'}>
                    {bill.type === 'income' ? '+' : '-'}{bill.amount}
                  </td>
                  <td>{bill.type === 'income' ? '收入' : '支出'}</td>
                  <td>{bill.description}</td>
                  <td>{bill.productName || '-'}</td>
                  <td>{bill.price || '-'}</td>
                  <td>{bill.quantity || '-'}</td>
                  <td>{bill.manufacturer || '-'}</td>
                  <td>
                    <button className="edit-button" onClick={() => handleEditBill(bill)}>编辑</button>
                    <button className="delete-button" onClick={() => handleDeleteBill(bill.id)}>删除</button>
                    <button className="print-button" onClick={() => handlePrintBill(bill)}>打印</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default BillManagement;